import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild, HostListener, OnDestroy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { UserService } from '../../layout/service/user.service';
import { SocketService } from '../../layout/service/socket.service';
import { CountdownComponent, CountdownModule, CountdownEvent } from 'ngx-countdown';
import { Location } from '@angular/common';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-room',
    imports: [
        ButtonModule,
        CommonModule,
        FormsModule,
        CountdownModule,
        ConfirmDialogModule
    ],
    providers: [ConfirmationService, MessageService],
    styles: [
        `
            .auth-card {
                max-width: 100%;
                width: 100%;
                padding: 2.5rem 2rem 2rem 2rem;
                border-radius: 1.25rem;
                box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.15);
                background: #fff;
                justify-content: center;
                text-align: center;
                margin: 0 auto;
                transition: box-shadow 0.2s;
            }
            .auth-card:focus-within {
                box-shadow: 0 12px 40px 0 rgba(31, 38, 135, 0.22);
            }
            .auth-title {
                color: #2563eb;
                font-size: 1.5rem;
                font-weight: 700;
                margin-bottom: 0.5rem;
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 0.5rem;
            }
            .auth-desc {
                color: #64748b;
                margin-bottom: 2rem;
                text-align: center;
                font-size: 1rem;
            }
            .otp-input {
                margin-bottom: 1.5rem;
            }
            .submit-btn {
                width: 100%;
                font-weight: 600;
                font-size: 1.1rem;
                border-radius: 0.5rem;
                height: 2.75rem;
            }
            .feedback {
                margin-top: 1.25rem;
                font-size: 1rem;
                text-align: center;
                min-height: 1.5rem;
            }
            .feedback.success {
                color: #22c55e;
            }
            .feedback.error {
                color: #ef4444;
            }
            .loading-spinner {
                margin-left: 0.5rem;
                border: 2px solid #2563eb;
                border-top: 2px solid #fff;
                border-radius: 50%;
                width: 1.2em;
                height: 1.2em;
                animation: spin 0.8s linear infinite;
                display: inline-block;
                vertical-align: middle;
            }
            @keyframes spin {
                0% {
                    transform: rotate(0deg);
                }
                100% {
                    transform: rotate(360deg);
                }
            }
            .participants-title {
                font-weight: 600;
                font-size: 1.1rem;
                margin-bottom: 1rem;
                color: #2563eb;
            }
            .participants-grid {
                display: grid;
                grid-template-columns: repeat(4, minmax(0, 1fr));
                gap: 1.25rem 1rem;
                margin-bottom: 1rem;
            }
            .participants-scroll {
                max-height: 420px;
                overflow-y: auto;
                padding-right: 4px;
            }
            .running-case {
                background: #e0f2fe;
                border: 2px solid #2563eb;
                color: #2563eb;
                border-radius: 0.75rem;
                font-weight: 700;
                font-size: 1.15rem;
                padding: 1.2rem 1.5rem;
                margin-bottom: 1.5rem;
                box-shadow: 0 2px 12px 0 rgba(31, 38, 135, 0.10);
                display: flex;
                align-items: center;
                gap: 1rem;
            }
            .running-case .case-title {
                font-size: 1.2rem;
                font-weight: 700;
            }
            @media (max-width: 900px) {
                .participants-grid {
                    grid-template-columns: repeat(2, minmax(0, 1fr));
                }
            }
            @media (max-width: 600px) {
                .participants-grid {
                    grid-template-columns: 1fr;
                }
            }
            .participant-card {
                background: #f8fafc;
                border-radius: 1rem;
                box-shadow: 0 2px 8px 0 rgba(31, 38, 135, 0.07);
                display: flex;
                flex-direction: column;
                align-items: center;
                padding: 1.1rem 0.5rem 0.9rem 0.5rem;
                transition:
                    box-shadow 0.2s,
                    transform 0.2s;
                position: relative;
                min-height: 120px;
                opacity: 1;
                transform: scale(1);
            }
            .participant-card.new {
                animation: fadeInScale 0.7s cubic-bezier(0.4, 2, 0.6, 1) both;
                box-shadow: 0 6px 24px 0 rgba(31, 38, 135, 0.18);
                border: 2px solid #2563eb;
            }
            .participant-card.leave {
                animation: fadeOutScale 0.7s cubic-bezier(0.4, 2, 0.6, 1) both;
                opacity: 0.3;
                pointer-events: none;
            }
            @keyframes fadeInScale {
                0% {
                    opacity: 0;
                    transform: scale(0.7);
                }
                80% {
                    opacity: 1;
                    transform: scale(1.08);
                }
                100% {
                    opacity: 1;
                    transform: scale(1);
                }
            }
            @keyframes fadeOutScale {
                0% {
                    opacity: 1;
                    transform: scale(1);
                }
                100% {
                    opacity: 0;
                    transform: scale(0.7);
                }
            }
            .avatar {
                width: 3.2rem;
                height: 3.2rem;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: 700;
                font-size: 1.3rem;
                color: #fff;
                background: #64748b;
                user-select: none;
                margin-bottom: 0.5rem;
                box-shadow: 0 2px 8px 0 rgba(31, 38, 135, 0.1);
                border: 3px solid #fff;
                transition: box-shadow 0.2s;
            }
            .participant-name {
                font-size: 1.05rem;
                color: #334155;
                font-weight: 600;
                text-align: center;
                word-break: break-word;
                margin-bottom: 0.2rem;
            }
            .participant-date {
                font-size: 0.85rem;
                color: #64748b;
                font-weight: 400;
                text-align: center;
            }
            .loader {
                width: 48px;
                height: 48px;
                border: 5px solid #fff;
                border-bottom-color: #1d4ed8;
                border-radius: 50%;
                display: inline-block;
                box-sizing: border-box;
                animation: rotation 1s linear infinite;
            }

            @keyframes rotation {
                0% {
                    transform: rotate(0deg);
                }
                100% {
                    transform: rotate(360deg);
                }
            }
            .timer-container {
                display: flex;
                justify-content: center;
                align-items: center;
                border: 3px solid #2563eb;
                border-radius: 1.5rem;
                padding: 1.5rem 2.5rem;
                background: #f1f5fd;
                margin-bottom: 1rem;
                min-width: 320px;
                min-height: 80px;
                box-shadow: 0 4px 24px 0 rgba(31, 38, 135, 0.10);
            }
            .timer-container countdown {
                font-size: 2.8rem !important;
                font-weight: 700;
                color: #2563eb;
                letter-spacing: 0.1em;
            }
        `
    ],
    template: `
        <p-confirmdialog />
        <div class="grid grid-cols-12 gap-8">
            <div class="lg:col-span-6 col-span-12">
                <div class="auth-card">
                    <div class="auth-title">
                        <i class="pi pi-desktop"></i>
                        Ruang Simulasi
                    </div>
                    <div class="auth-desc">
                        Kode Ruangan: <span class="font-semibold text-blue-600">{{ code }}</span>
                    </div>
                </div>
                <div class="auth-card mt-8 p-4" *ngIf="forms.length > 0" style="margin-top: 2rem">
                    <div *ngIf="forms[0]?.osce?.length && caseStatuses.includes('running')" class="running-case">
                        <span class="pi pi-bolt text-2xl"></span>
                        <span class="case-title">
                            {{ forms[0].osce[currentCaseIndex]?.TITLE || '-' }}
                        </span>
                        <span class="ml-2 text-xs font-semibold px-2 py-1 rounded bg-blue-200 text-blue-800">Sedang Berjalan</span>
                    </div>
                    <div class="text-lg font-semibold mb-4">Kasus</div>
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div *ngFor="let osce of forms[0]?.osce; let idx = index"
                            class="flex items-center gap-4 p-4 rounded-lg bg-gray-50 shadow-sm border border-gray-200"
                            [ngClass]="{'border-blue-400 bg-blue-50': caseStatuses[idx] === 'running'}"
                        >
                            <div class="flex-1">
                                <div class="text-left font-bold text-blue-700 text-base">{{ osce.TITLE }}</div>
                                <div class="text-left text-xs text-gray-500">{{ osce.KATEGORI }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="lg:col-span-6 col-span-12 auth-card w-full">
                <div class="participants-title">
                    Peserta <span class="text-xs text-gray-500">({{ participants.length }})</span>
                </div>
                <div class="participants-scroll">
                    <div class="flex justify-center items-center" style="margin-top: 4rem" *ngIf="loadingParticipants">
                        <div class="loader-container text-center">
                            <div class="loader"></div>
                            <div class="loader-text font-semibold mt-2">Mohon tunggu, sedang mengambil data peserta</div>
                        </div>
                    </div>
                    <div *ngIf="participants && participants.length > 0">
                        <div class="participants-grid" style="grid-template-columns: repeat(2, minmax(0, 1fr));">
                            <div
                                *ngFor="let p of participants"
                                class="participant-card"
                                [ngClass]="{'new': p.isNew, 'leave': p.isLeaving}"
                                (click)="onParticipantClick(p)"
                                style="cursor:pointer;"
                            >
                                <div class="avatar" [ngStyle]="{'background-color': getAvatarColor(p)}">
                                    {{ getInitials(p.name) }}
                                </div>
                                <span class="participant-name">{{ p.name }}</span>
                                <span class="participant-date">{{ p.created_at | date:'short' }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `
})
export class Room implements OnInit, OnDestroy {
    code: string | null = null;
    forms: any[] = [];
    participants: any[] = [];
    loadingParticipants = false;
    error = false;
    feedbackMsg = '';
    messages: any;
    countdownConfig: any = null;
    @ViewChild('countdown', { static: false }) countdown!: CountdownComponent;

    currentCaseIndex: number = 0;
    caseStatuses: string[] = [];
    simulationStateKey = '';

    private prevParticipantIds: Set<string> = new Set();
    private socketSubscription: any;
    private leavingTimeout: any;
    private newTimeout: any;

    constructor(
        private route: ActivatedRoute,
        private userService: UserService,
        private socketService: SocketService,
        private location: Location,
        private confirmationService: ConfirmationService,
        private messageService: MessageService,
        private router: Router
    ) {}

    @HostListener('window:beforeunload', ['$event'])
    handleBeforeUnload(event: BeforeUnloadEvent) {
        // Tampilkan native browser confirm jika simulasi masih berjalan
        if (this.caseStatuses.includes('running')) {
            event.preventDefault();
            event.returnValue = ''; // Chrome requires returnValue to be set
            return '';
        }
        return undefined;
    }

    ngOnInit(): void {
        this.code = this.route.snapshot.paramMap.get('code');
        this.simulationStateKey = `simulation_room_${this.code}`;

        this.socketSubscription = this.socketService.listen('receive-message').subscribe((data: any) => {
            this.messages = data;

            if (this.messages.code == this.code) {
                if (this.messages.status == 'start' || this.messages.status == 'next') {
                    // Sinkronkan timer dan current_case jika pesan dari room
                    if (this.messages.current_case) {
                        try {
                            const currentCaseObj = JSON.parse(this.messages.current_case);
                            const idx = this.forms[0]?.osce?.findIndex((c: any) => c.ID_OSCE === currentCaseObj.ID_OSCE);
                            if (idx !== -1) {
                                this.currentCaseIndex = idx;
                                this.caseStatuses = this.forms[0].osce.map((_: any, i: number) =>
                                    i < idx ? 'finish' : (i === idx ? 'running' : 'waiting')
                                );
                                // Always use remaining_time from socket message
                                const leftTime = this.messages.remaining_time || this.forms[0].duration || 60;
                                this.countdownConfig = {
                                    leftTime: leftTime,
                                    format: 'HH:mm:ss',
                                    demand: true
                                };
                                setTimeout(() => {
                                    if (this.countdown) this.countdown.restart();
                                    setTimeout(() => {
                                        if (this.countdown) this.countdown.begin();
                                    }, 0);
                                }, 0);
                                this.saveSimulationState(leftTime);
                            }
                        } catch {}
                    }
                }
                if (this.messages.status == 'waiting') {
                    this.getParticipant();
                }
            }
        });
        this.userService.getPackageSimulation().then((res) => {
            this.forms = res.data;
            this.forms = this.forms.filter((form) => form.code === this.code);
            this.forms = this.forms.map((form) => {
                form.osce = JSON.parse(form.osce_id);
                return form;
            });
            this.getParticipant();

            // Restore state if available
            const savedState = localStorage.getItem(this.simulationStateKey);
            let restored = false;
            let initialLeftTime = this.forms[0].duration;
            if (this.forms.length > 0 && this.forms[0].duration) {
                initialLeftTime = this.forms[0].duration;
            }
            if (savedState) {
                try {
                    const state = JSON.parse(savedState);
                    // Perbaikan: pastikan jumlah caseStatuses sama dengan jumlah osce
                    const osceLength = this.forms[0]?.osce?.length || 0;
                    if (
                        state.currentCaseIndex !== undefined &&
                        Array.isArray(state.caseStatuses) &&
                        state.leftTime !== undefined &&
                        state.lastSaved !== undefined &&
                        osceLength > 0
                    ) {
                        // Jika jumlah status tidak sama, perbaiki array status
                        if (state.caseStatuses.length !== osceLength) {
                            // Buat array baru dengan status default
                            const newStatuses = Array(osceLength).fill('waiting');
                            // Copy status yang sudah ada
                            for (let i = 0; i < Math.min(state.caseStatuses.length, osceLength); i++) {
                                newStatuses[i] = state.caseStatuses[i];
                            }
                            state.caseStatuses = newStatuses;
                        }
                        // Calculate elapsed time since lastSaved
                        const now = Date.now();
                        let leftTime = state.leftTime;
                        if (state.caseStatuses.includes('running')) {
                            const elapsed = Math.floor((now - state.lastSaved) / 1000);
                            leftTime = Math.max(0, leftTime - elapsed);
                        }
                        this.currentCaseIndex = state.currentCaseIndex;
                        this.caseStatuses = state.caseStatuses;
                        this.countdownConfig = {
                            leftTime: leftTime,
                            format: 'HH:mm:ss',
                            demand: true
                        };
                        restored = true;
                    }
                } catch {}
            }

            // If not restored, initialize state
            if (!restored && this.forms.length > 0 && this.forms[0].osce?.length > 0) {
                this.currentCaseIndex = 0;
                this.caseStatuses = this.forms[0].osce.map((_: any, idx: number) => idx === 0 ? 'waiting' : 'waiting');
                this.countdownConfig = {
                    leftTime: initialLeftTime, // gunakan duration dari forms jika ada
                    format: 'HH:mm:ss',
                    demand: true
                };
            }

            Object.keys(localStorage).forEach(key => {
                if (
                    key.startsWith('simulation_room_')
                ) {
                    if(key !== this.simulationStateKey){
                        localStorage.removeItem(key);
                        this.getParticipant();
                    } else {
                        this.getParticipant();
                        setTimeout(() => this.autoStartSimulation(), 0);
                    }
                }
            });
        });

    }

    autoStartSimulation() {
        if (this.forms.length === 0 || !this.forms[0].osce?.length) return;
        // If not running, start first case
        if (!this.caseStatuses.includes('running')) {
            this.currentCaseIndex = 0;
            this.caseStatuses = this.forms[0].osce.map((_: any, idx: number) => idx === 0 ? 'running' : 'waiting');
            if (this.countdown) {
                this.countdownConfig = {
                    leftTime: this.forms[0].duration || 60,
                    format: 'HH:mm:ss',
                    demand: true
                };
                setTimeout(() => this.countdown.begin(), 0);
            }
            this.saveSimulationState(this.forms[0].duration || 60);
        } else {
            // If running, continue timer with current leftTime from localStorage
            const savedState = localStorage.getItem(this.simulationStateKey);
            let leftTime = this.forms[0].duration || 60;
            if (savedState) {
                try {
                    const state = JSON.parse(savedState);
                    if (state.leftTime !== undefined && state.lastSaved !== undefined) {
                        const now = Date.now();
                        if (this.caseStatuses.includes('running')) {
                            const elapsed = Math.floor((now - state.lastSaved) / 1000);
                            leftTime = Math.max(0, state.leftTime - elapsed);
                        }
                    }
                } catch {}
            }
            if (this.countdown) {
                this.countdownConfig = {
                    leftTime: leftTime,
                    format: 'HH:mm:ss',
                    demand: true
                };
                setTimeout(() => this.countdown.begin(), 0);
            }
        }
    }

    startSimulation() {
        // Ambil current case object, stringify
        let currentCaseObj = null;
        if (this.forms.length > 0 && this.forms[0].osce && this.forms[0].osce[this.currentCaseIndex]) {
            currentCaseObj = this.forms[0].osce[this.currentCaseIndex];
        }
        this.userService.simulationStart({
            code: this.code,
            status: 'running',
            remaining_time: this.countdownConfig.leftTime,
            current_case: JSON.stringify(currentCaseObj)
        }).then((res) => {
            // Always send the latest timer value to all participants
            setTimeout(() => this.send('start', currentCaseObj, this.countdownConfig.leftTime), 500);
            this.autoStartSimulation();
        });
    }

    // Ubah signature send untuk mengirim data tambahan
    send(status: string, currentCaseObj?: any, remaining_time?: number): void {
        const message = {
            code: this.code,
            status: status,
            current_case: currentCaseObj ? JSON.stringify(currentCaseObj) : null,
            remaining_time: remaining_time
        };
        this.socketService.emit('send-message', message);
    }

    onCountdownEvent(event: CountdownEvent) {
        if (event.action === 'done') {
            if (this.forms.length === 0 || !this.forms[0].osce?.length) return;
            const totalCases = this.forms[0].osce.length;
            if (this.currentCaseIndex < totalCases) {
                this.caseStatuses[this.currentCaseIndex] = 'finish';
            }
            if (this.currentCaseIndex + 1 < totalCases) {
                // Masih ada soal berikutnya, lanjut ke next
                this.currentCaseIndex++;
                this.caseStatuses = this.forms[0].osce.map((_: any, i: number) =>
                    i < this.currentCaseIndex ? 'finish' : (i === this.currentCaseIndex ? 'running' : 'waiting')
                );
                if (this.countdown) {
                    this.countdownConfig = {
                        leftTime: this.forms[0].duration || 60,
                        format: 'HH:mm:ss',
                        demand: true
                    };
                    setTimeout(() => {
                        this.countdown.restart();
                        setTimeout(() => {
                            this.countdown.begin();
                        }, 0);
                    }, 0);
                }
                let nextCaseObj = this.forms[0].osce[this.currentCaseIndex];
                this.userService.simulationStart({
                    code: this.code,
                    status: 'running',
                    remaining_time: this.forms[0].duration || 60,
                    current_case: JSON.stringify(nextCaseObj)
                }).then(() => {
                    // Pastikan send next hanya dikirim setelah simulationStart selesai
                    this.send('next', nextCaseObj, this.countdownConfig.leftTime || 60);
                });
                this.saveSimulationState(this.forms[0].duration || 60);
            } else if (this.currentCaseIndex + 1 === totalCases) {
                // Ini adalah soal terakhir, tandai sebagai finish setelah selesai
                this.caseStatuses[this.currentCaseIndex] = 'finish';
                // Tunggu hingga semua caseStatuses sudah 'finish'
                const allFinished = this.caseStatuses.every(s => s === 'finish');
                if (allFinished) {
                    this.userService.simulationStart({
                        code: this.code,
                        status: 'finished'
                    }).then(() => {
                        this.send('finished');
                    });
                    localStorage.removeItem(this.simulationStateKey);
                }
            }
        } else if (event.action === 'notify' && event.left !== undefined) {
            // Save timer state on every tick, also save timestamp
            this.saveSimulationState(event.left);
        }
    }

    saveSimulationState(leftTime: number) {
        // Simpan juga current case object dalam bentuk JSON
        let currentCaseObj = null;
        if (this.forms.length > 0 && this.forms[0].osce && this.forms[0].osce[this.currentCaseIndex]) {
            currentCaseObj = this.forms[0].osce[this.currentCaseIndex];
        }
        const now = Date.now();
        const state = {
            currentCaseIndex: this.currentCaseIndex,
            caseStatuses: this.caseStatuses,
            leftTime,
            lastSaved: now,
            currentCase: currentCaseObj ? JSON.stringify(currentCaseObj) : null
        };
        localStorage.setItem(this.simulationStateKey, JSON.stringify(state));
    }

    getStatusClass(status: string): string {
        switch (status) {
            case 'waiting':
                return 'bg-blue-100 text-blue-700 border border-blue-200';
            case 'pending':
                return 'bg-yellow-100 text-yellow-700 border border-yellow-200';
            case 'finish':
                return 'bg-green-100 text-green-700 border border-green-200';
            default:
                return 'bg-gray-100 text-gray-700 border border-gray-200';
        }
    }

    getParticipant(): Promise<any> {

        this.loadingParticipants = true;
        const payload = {
            code: this.code
        }
        return this.userService.simulationParticipant(payload).then((response) => {
            const oldIds = new Set(this.participants.map(p => p.id));
            const newIds = response.data.map((p: any) => p.id);
            const prevIds = this.participants.map(p => p.id);

            const leaving = this.participants.filter(
                p => !newIds.includes(p.id)
            ).map(p => ({ ...p, isLeaving: true }));

            const newList = response.data.map((p: any) => {
                return {
                    ...p,
                    isNew: !oldIds.has(p.id),
                    isLeaving: false
                };
            });

            this.participants = [...newList, ...leaving];

            if (leaving.length > 0) {
                this.leavingTimeout = setTimeout(() => {
                    this.participants = this.participants.filter(p => !p.isLeaving);
                }, 700);
            }

            this.newTimeout = setTimeout(() => {
                this.participants = this.participants.map(p => ({ ...p, isNew: false }));
            }, 1500);

            this.prevParticipantIds = new Set(this.participants.map(p => p.id));
            this.loadingParticipants = false;
        }).catch((error) => {
            this.error = true;
            this.feedbackMsg = this.error ? error.error.message : 'An error occurred. Please try again.';
            this.loadingParticipants = false;
        });
    }

    // Helper for avatar initials
    getInitials(name: string): string {
        if (!name) return '';
        const words = name.trim().split(' ');
        if (words.length === 1) {
            return words[0].substring(0, 2).toUpperCase();
        }
        return (words[0][0] + words[1][0]).toUpperCase();
    }

    // Helper for avatar color
    getAvatarColor(p: any): string {
        const colors = [
            '#2563eb', '#f59e42', '#10b981', '#e11d48', '#a21caf', '#64748b', '#fbbf24', '#0ea5e9'
        ];
        let hash = 0;
        const str = p.user_id || p.name || '';
        for (let i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }
        const idx = Math.abs(hash) % colors.length;
        return colors[idx];
    }

    handleLeaveRoom(): Promise<boolean> | boolean {
        if (this.caseStatuses.includes('running')) {
            return new Promise<boolean>((resolve) => {
                this.confirmationService.confirm({
                    message: 'Simulasi masih berjalan. Apakah Anda yakin ingin keluar?',
                    header: 'Konfirmasi',
                    icon: 'pi pi-exclamation-triangle',
                    acceptLabel: 'Ya, Keluar',
                    rejectLabel: 'Batal',
                    accept: () => {
                        resolve(true);
                    },
                    reject: () => {
                        resolve(false);
                    }
                });
            });
        }
        return true;
    }

    // Optionally, if using Angular router navigation, use this:
    canDeactivate(): Promise<boolean> | boolean {
        return this.handleLeaveRoom();
    }

    ngOnDestroy(): void {
        // Bersihkan subscription socket jika ada
        if (this.socketSubscription && typeof this.socketSubscription.unsubscribe === 'function') {
            this.socketSubscription.unsubscribe();
        }
        // Bersihkan timeout animasi peserta jika ada
        if (this.leavingTimeout) {
            clearTimeout(this.leavingTimeout);
        }
        if (this.newTimeout) {
            clearTimeout(this.newTimeout);
        }
    }

    onParticipantClick(p: any) {
        // Navigasi ke halaman start dengan USER_ID dan name sebagai query param
        this.router.navigate(['app/osce/simulation/start', this.code], { queryParams: { user_id: p.user_id, name: p.name, simulation_id: p.id } });
    }
}
